import React from "react";

const EmojiSectionSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-6 items-center">
      <div className="col-span-2 flex overflow-hidden">
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <div
            key={item}
            className="relative h-36 w-36 max-md:w-28 max-md:h-28 max-sm:w-24 max-sm:h-24 mx-4 max-md:mx-2 skeleton flex-shrink-0"
          ></div>
        ))}
      </div>

      <div className="flex flex-col items-end gap-4">
        <span className="skeleton w-[260px] max-md:w-[200px] h-12"></span>
        <span className="skeleton w-[340px] max-md:w-[260px] h-12"></span>
      </div>
    </div>
  );
};

export default EmojiSectionSkeleton;
